const roles = {
  superadmin: {
    description:
      'Super Admin CDVI - A accès à toutes les fonctionnalités et paramètres.',
  },
  customer_support: {
    description:
      'Support client CDVI - A accès aux fonctionnalités et paramètres support du client.',
  },
  administration: {
    description: 'Administration CDVI - A accès à ???.',
  },
  marketing: {
    description: 'Marketing CDVI - A accès à ???.',
  },
  dealer_administrator: {
    description:
      'Administrateur Installateur - A accès à tout dans le compte installateur.',
  },
  dealer_accounts_manager: {
    description:
      "Gestionnaire de comptes de l'installateur - A accès à la gestion des comptes de l'installateur.",
  },
  account_administrator: {
    description: 'Administrateur de compte - A accès à tout dans le compte.',
  },
  account_site_manager: {
    description: 'Gestionnaire de site - A accès complet à un site spécifique.',
  },
  account_door_manager: {
    description:
      'Gestionnaire des portes - A accès aux fonctionnalités de gestion des portes.',
  },
};

export default roles;
